import React from 'react';
import _ from 'lodash';

import { RAPIDA_FACE_IMAGE_RANGE_RESOLUTION } from '@bld/bld-libs/constants';
import { compressImage } from '@bld/bld-libs/utils';

import WorkerSettingsContext from './WorkerSettingsContext';
import WorkerSettingsApi from './WorkerSettingsApi';
import WorkerSettingsService from './WorkerSettingsService';
import WorkerSettingApi from './WorkerSettingsApi';
import WorkerImageApi from '../workers/workerImage/WorkerImageApi';
import WorkerImageService from '../workers/workerImage/WorkerImageService';
import FieldSettingsApi from '../fieldSettings/FieldSettingsApi';
import FieldWorkerImageStatusesApi from '../fieldWorkerImageStatuses/FieldWorkerImageStatusesApi';
import FieldApi from '../field/FieldApi';
import LocalStorageService from '../utilities/LocalStorageService';
import SessionStorageService from '../utilities/SessionStorageService';
import { extractErrorMessage } from '../../utilities/commonUtil';
import { messageUtility } from '../../utilities/messageUtility';
import { isPrimaryCompanyRoleId } from '../../utilities/roleUtility';
import EventMg, { EventType } from '../../utilities/EventManager';
import { isNullOrEmpty } from '../../utilities/stringUtil';
import {
  DIALOG_STATUS,
  WORKER_IMAGE_REGISTER_STATUS,
  WORKER_IMAGE_CCUS_SYNCED_STATUS,
  ERROR_MESSAGE,
  SORT_TYPE,
  FACE_PICTURE_UPLOAD_STATUS,
  WORKER_SETTING_TAB,
  FIELD_TREE_WORKER_CCUS_SYNCED_STATUS,
  CCUS_ENGINEER_ID_STATUS,
  CONNECT_WORK_HISTORY_STATUS,
  WORKER_SETTING_STATUS,
} from '../../utilities/constants';

const BLACKLIST_SEARCH_KEYS = {
  [WORKER_SETTING_TAB.FACE_PICTURE.id]: [
    'ccus_engineer_ids',
    'field_connect_work_history_status',
    'field_tree_worker_ccus_synced_status',
  ],
  [WORKER_SETTING_TAB.CCUS.id]: ['worker_image_ccus_synced_status'],
};

/**
 * 作業員設定状況一覧のstate管理用コンポーネント
 * */
export default class WorkerSettingsStore extends React.Component {
  state = {
    isLoading: true, // API等でローディング中フラグ
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示ステータス,
    showImageSettingErrorDialog: false, // 顔写真選択時エラーダイアログ表示フラグ
    roleId: LocalStorageService.getRoleId(), // ログイン中ユーザーの権限
    canUseFaceRegisterButton: false, // 顔画像登録ボタン活性フラグ
    fieldId: null, // 現場ID
    workerList: [], // 現場作業員一覧
    detailWorker: {
      // 詳細ダイアログ表示時のプロパティ
      workerId: null, // 作業員ID
      fieldTreeWorkerId: null, // 施工体系ID
      imageUrl: null, // 顔写真URL
      fullName: null, // 作業員名
      companyName: null, // 所属会社名
      primaryCompanyName: null, // 一時協力会社名
      workerStatus: null, // 作業員ステータス
      ccusSyncedStatus: null, // 顔認証機器連携状態
      hasError: false, // エラー状況
      errorMessage: null, // エラーメッセージ
      exclusionReason: null, // エラーメッセージ
    },
    workerImage: {
      // 作業員顔写真ダイアログ用プロパティ
      workerId: null, // 作業員ID
      fieldTreeWorkerId: null, // 施工体系ID
      imageUrl: '', // 顔写真URL
      imageBinary: '', // 顔写真バイナリデータ
      imageName: '', // 顔写真名
      uploadStatus: FACE_PICTURE_UPLOAD_STATUS.notChangedFile.id, //顔写真アップロードステータス
    },
    informationModal: {
      // インフォメーションモーダル用プロパティ
      title: null, // モーダルダイアログのタイトル
      message: null, // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
      multilineText: false, // モーダルダイアログメッセージには複数の行がある場合
    },
    searchForm: {
      // 検索フォーム用プロパティ
      total: 0, // 検索結果件数
      offset: 0, // 検索時の初期件数
      limit: null,
      fieldTreeIds: [], // 所属会社
      companyIds: [], // 一次協力会社
      workerName: '', // 氏名
      workerSettingStatusList: [], // ステータス ( 0:稼働中、1:作業終了、2:退職)
      workerImageRegisterStatusList: [], // 顔写真 (0: 無、1: 有)
      workerImageCcusSyncedStatusList: [], // 顔認証機器連携 (0: 未登録、1: 登録済)
      hasErrorList: [], // エラー状況 (0: 無、1: 有、2: すべて)
      fieldTreeWorkerCcusSyncedStatusList: [], // 施工体系作業員CCUS連携ステータス (0: 未連携、1: 連携中、2: 連携済み、3: 連携エラー)
      selectAll: true,
      fieldCcusEngineerIdStatus: [], // CCUS技能者ID (0: 登録済, 1: 未登録)
      fieldConnectWorkHistoryStatus: [], // 就業履歴連携 (0: 対象外, 1: 連携可)
      order: '', // ソート項目
      sortType: '',
      isOpened: true, // 検索フォームトグルの開閉フラグ
      clearFlag: false, //セレクトボックス検索条件クリアフラグ
    },
    infiniteScrollLoadSearchForm: {
      total: 0, // 検索結果件数
      offset: 0, // 検索時の初期件数
      limit: null,
      fieldTreeIds: [], // 所属会社
      companyIds: [], // 一次協力会社
      workerName: '', // 氏名
      workerSettingStatusList: [], // ステータス ( 0:稼働中、1:作業終了、2:退職)
      workerImageRegisterStatusList: [], // 顔写真 (0: 無、1: 有)
      workerImageCcusSyncedStatusList: [], // 顔認証機器連携 (0: 未登録、1: 登録済)
      hasErrorList: [], // エラー状況 (0: 無、1: 有、2: すべて)
      fieldTreeWorkerCcusSyncedStatusList: [], // 施工体系作業員CCUS連携ステータス (0: 未連携、1: 連携中、2: 連携済み、3: 連携エラー)
      fieldCcusEngineerIdStatus: [], // CCUS技能者ID (0: 登録済, 1: 未登録)
      fieldConnectWorkHistoryStatus: [], // 就業履歴連携 (0: 対象外, 1: 連携可)
      order: '', // ソート項目
      sortType: '',
      isOpened: false, // 検索フォームトグルの開閉フラグ
    },
    fieldTreeBranchSearchForm: {
      // 検索フォーム用プロパティ
      total: 0, // 検索結果件数
      offset: 0, // 検索時の初期件数
      name: '', // 氏名
      deduplicationflag: 0, // 重複を排除しない
      primaryDisplayFlag: 1, // 表示形式を「1次協力会社（自社）」にする
    },
    showTab: false, // タブ情報を表示するか？
    selectedTabId: WORKER_SETTING_TAB.FACE_PICTURE.id, // 初期表示のタブは顔写真tabにする
    isVisibleThumbnails: false,
    canLoadMore: true,
    ccusSecededWarning: false,
    jvFlag: false,
    isCsvExportErrorDialog: false, // CSV出力時エラーダイアログ表示フラグ
  };

  /**
   * タブを変更する
   * @param {Number}tabId:表示したいタブID
   * */
  changeTab = tabId => {
    // BLDE_V2-51612: データのロード中はタブを変更させない
    if (this.state.isLoading) {
      return;
    }
    const isCcusTab = tabId === WORKER_SETTING_TAB.CCUS.id;
    this.setState({ selectedTabId: tabId }, () => {
      this.clearSearchProperty('searchForm', false, isCcusTab);
    });
  };

  /**
   * 検索フォームの開閉トグル
   * @param {string}propertyName:ステート内のプロパティ名
   * */
  searchFormHandle = propertyName => {
    let state = { ...this.state };
    state[propertyName].isOpened = !state[propertyName].isOpened;
    this.setState(state);
  };

  /**
   * 所属会社IDで検索
   * */
  searchFieldTreeId = fieldTreeIds => {
    const state = _.cloneDeep(this.state);
    state.searchForm.fieldTreeIds = fieldTreeIds;
    this.setState(state);
  };

  searchCompanyId = companyIds => {
    const state = _.cloneDeep(this.state);
    state.searchForm.companyIds = companyIds;
    this.setState(state);
  };
  // BLDE_V2-42611  ドロップダウンにあるチェックボックスを用いて、連携状態を検索条件に追加する
  // BLDE_V2-50576 「連携解除」の検索条件はCCUS事業者IDが削除された作業員を検索する
  searchConnectStatus = ccusSyncedStatus => {
    const state = _.cloneDeep(this.state);
    const mappedCcusSyncedStatus = _.map(ccusSyncedStatus, id => {
      return _.find(FIELD_TREE_WORKER_CCUS_SYNCED_STATUS, { ID: id });
    });
    state.searchForm.fieldTreeWorkerCcusSyncedStatusList = mappedCcusSyncedStatus;
    this.setState(state);
  };
  /**
   * 検索フォームの作業員名を入力
   * @param {object}event:入力された作業員名
   * */
  inputWorkerName = event => {
    const state = _.cloneDeep(this.state);
    const { name, value } = event.target;
    state[name].workerName = value;
    this.setState(state);
  };

  /**
   * チェックボックス1件更新
   * @param {string}propertyName:ステート内のプロパティ名
   * @param {object}item:1件のオブジェクト(選択した項目)
   * */
  checkSingleData = (propertyName, item) => {
    if (!item.hasOwnProperty('id') && !item.hasOwnProperty('ID')) {
      return;
    }

    const state = _.cloneDeep(this.state);
    const isUnchecking =
      !_.isEmpty(state.searchForm[propertyName]) &&
      _.some(state.searchForm[propertyName], item);
    const items = isUnchecking
      ? state.searchForm[propertyName].filter(value => !_.isEqual(value, item))
      : [...state.searchForm[propertyName], item];
    state.searchForm[propertyName] = items;

    this.setState(state);
  };

  /**
   * 検索条件をクリアする
   * @param {string}propertyName:ステート内のプロパティ名
   * @param {boolean}clearSort:ソートをクリアするか？
   * @param {boolean}isCcusTab
   * */
  clearSearchProperty = async (propertyName, clearSort = true, isCcusTab) => {
    const state = _.cloneDeep(this.state);
    state[propertyName].clearFlag = true;
    state[propertyName].fieldTreeIds.length = 0;
    state[propertyName].companyIds.length = 0;
    state[propertyName].workerName = '';
    state[propertyName].workerSettingStatusList = _.values(
      WORKER_SETTING_STATUS
    );
    state[propertyName].workerImageRegisterStatusList = _.values(
      WORKER_IMAGE_REGISTER_STATUS
    );
    state[propertyName].workerImageCcusSyncedStatusList = _.values(
      _.filter(WORKER_IMAGE_CCUS_SYNCED_STATUS, 'canSearch')
    );
    state.searchForm.fieldTreeWorkerCcusSyncedStatusList = _.values(
      FIELD_TREE_WORKER_CCUS_SYNCED_STATUS
    );
    state.searchForm.selectAll = true;
    state.searchForm.fieldCcusEngineerIdStatus = _.values(
      CCUS_ENGINEER_ID_STATUS
    );
    state.searchForm.fieldConnectWorkHistoryStatus = _.values(
      CONNECT_WORK_HISTORY_STATUS
    );
    state[propertyName].workerSettingStatusList.length = 1;
    state[propertyName].hasErrorList.length = 0;

    if (clearSort) {
      state[propertyName].order = '';
      state[propertyName].sortType = '';
    }
    state.infiniteScrollLoadSearchForm = {
      ...state.infiniteScrollLoadSearchForm,
      ...state.searchForm,
    };
    if (isCcusTab) {
      const response = await WorkerSettingsApi.fetchMainJvSecededCcus(
        state.fieldId
      );
      state.ccusSecededWarning = _.get(
        response,
        'data.entities.ccus_seceded_warning'
      );
      state.jvFlag = _.get(response, 'data.entities.sub_jv_exists_flag');
    }

    this.setState(this.clearListInfo(state), () => {
      this.loadWorkerSettingsList();
    });
  };

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    let state = { ...this.state };
    state = this.clearDialogStatus(state);
    state = this.clearDetailWorker(state);
    this.setState(state);
  };

  /**
   * ダイアログ周りのステータスを初期化する
   * @param {object}state:ステート情報
   * */
  clearDialogStatus = state => {
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = null;
    state.informationModal.buttonText = null;
    state.informationModal.multilineText = false;
    return state;
  };

  /**
   * 詳細表示していた作業員のプロパティを初期化する
   * @param {object}state:ステート情報
   * */
  clearDetailWorker = state => {
    state.detailWorker.workerId = null;
    state.detailWorker.fieldTreeWorkerId = null;
    state.detailWorker.imageUrl = null;
    state.detailWorker.fullName = null;
    state.detailWorker.companyName = null;
    state.detailWorker.workerStatus = null;
    state.detailWorker.primaryCompanyName = null;
    state.detailWorker.workerImageInfo = null;
    state.detailWorker.exclusionReason = null;
    return state;
  };

  /**
   * 作業員顔写真ダイアログ用のプロパティを初期化する
   * @param {object}state:ステート情報
   * */
  clearWorkerImage = state => {
    state.workerImage.workerId = null;
    state.workerImage.fieldTreeWorkerId = null;
    state.workerImage.imageUrl = '';
    state.workerImage.imageBinary = '';
    state.workerImage.imageName = '';
    state.workerImage.uploadStatus =
      FACE_PICTURE_UPLOAD_STATUS.notChangedFile.id;
    return state;
  };

  /**
   * 現場未選択モーダルを表示する
   * @param {object}state:ステート情報
   * */
  showNotExistFieldIdDialog = state => {
    state.dialogStatus = DIALOG_STATUS.notExistFieldIdDialogEnabled.id;
    state.informationModal.title = null;
    state.informationModal.message = messageUtility.getMessage('E-002-001-006');
    state.informationModal.buttonText = messageUtility.getMessage('I-000-017');
    return state;
  };

  /**
   * 無限スクロールから呼び出される
   * @param {function}notify
   * */
  infiniteScrollLoad = notify => {
    if (!notify) {
      return;
    }

    const {
      isLoading,
      canLoadMore,
      infiniteScrollLoadSearchForm,
    } = _.cloneDeep(this.state);

    if (isLoading) {
      notify();
      return;
    }

    if (canLoadMore) {
      this.loadWorkerSettingsList(infiniteScrollLoadSearchForm);
      notify();
    } else {
      notify('end');
    }
  };

  /**
   * ソート
   * @param {string}sortName:ソートしたい名前
   * */
  changeSort = sortName => {
    const state = _.cloneDeep(this.state);
    if (state.searchForm.sortType === SORT_TYPE.asc.id) {
      state.searchForm.sortType = SORT_TYPE.desc.id;
    } else {
      state.searchForm.sortType = SORT_TYPE.asc.id;
    }

    if (state.searchForm.order !== sortName) {
      state.searchForm.order = sortName;
      state.searchForm.sortType = SORT_TYPE.asc.id;
    }

    state.infiniteScrollLoadSearchForm.order = state.searchForm.order;
    state.infiniteScrollLoadSearchForm.sortType = state.searchForm.sortType;
    state.infiniteScrollLoadSearchForm.offset = 0;
    state.infiniteScrollLoadSearchForm.limit = null;
    this.setState(this.clearListInfo(state), () => {
      this.loadWorkerSettingsList(state.infiniteScrollLoadSearchForm);
    });
  };

  /**
   * 詳細ダイアログを表示する
   * @param {object}worker:作業員
   */
  showDetailDialog = worker => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.confirmDialogEnabled.id;
    if (worker === null || worker === undefined) {
      this.setState(state);
      return;
    }
    state.detailWorker.workerId = worker.worker_id;
    state.detailWorker.fieldTreeWorkerId = worker.field_tree_worker_id;
    state.detailWorker.fullName = worker.fullname;
    state.detailWorker.companyName = worker.company_name;
    state.detailWorker.workerStatus = worker.worker_status;
    state.detailWorker.primaryCompanyName = worker.primary_company_name;
    state.detailWorker.exclusionReason = worker.worker_image_exclusion_reason;
    state.detailWorker.workerImageInfo = worker.worker_image_info;
    if (
      worker.worker_image_register_status ===
      WORKER_IMAGE_REGISTER_STATUS.register.id
    ) {
      WorkerImageApi.fetchFacePicture(
        state.detailWorker.workerId,
        WorkerImageService.createSearchWorkerFacePicture(state.detailWorker)
      )
        .then(response => {
          if (response.result) {
            state.detailWorker.imageUrl = response.data.entities.image_url;
          } else {
            alert(response.message);
          }
        })
        .catch(error => {
          alert(error);
        })
        .finally(() => {
          this.setState(state);
        });
    } else {
      this.setState(state);
    }
  };

  /**
   * 顔写真登録・編集ダイアログを表示する
   */
  showImageSettingDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.imageSettingDialogEnabled.id;
    state.workerImage.workerId = state.detailWorker.workerId;
    state.workerImage.fieldTreeWorkerId = state.detailWorker.fieldTreeWorkerId;
    state.workerImage.imageUrl = state.detailWorker.imageUrl;
    this.setState(state);
  };

  /**
   * 顔写真登録・編集ダイアログを閉じる
   */
  closeImageSettingDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.confirmDialogEnabled.id;
    state = this.clearWorkerImage(state);
    this.setState(state);
  };

  /**
   * 顔写真選択時エラーダイアログを非表示にする
   */
  closeImageSettingErrorDialog = () => {
    let state = { ...this.state };
    state.showImageSettingErrorDialog = false;
    state.informationModal.title = null;
    state.informationModal.message = null;
    state.informationModal.buttonText = null;
    this.setState(state);
  };

  /**
   * 編集ダイアログの画像URLを初期化する
   * */
  deleteWorkerImage = () => {
    let state = { ...this.state };
    state.workerImage.imageUrl = '';
    state.workerImage.imageBinary = '';
    state.workerImage.imageName = '';
    state.workerImage.uploadStatus = FACE_PICTURE_UPLOAD_STATUS.deleteFile.id;
    this.setState(state);
  };

  /**
   * 顔写真をアップロードする
   */
  fileUpload = async (
    isValidSize,
    isValidType,
    isValidRangeResolution,
    fileName,
    imageBlob,
    callback
  ) => {
    this.setState({ isLoading: true });
    const state = _.cloneDeep(this.state);
    let errorMessage = null;
    let title = '';
    if (isNullOrEmpty(errorMessage) && !isValidSize) {
      errorMessage = messageUtility.getMessage('E-000-201-01');
    } else if (isNullOrEmpty(errorMessage) && !isValidType) {
      errorMessage = messageUtility.getMessage('E-000-201-02');
    } else if (isNullOrEmpty(errorMessage) && !isValidRangeResolution) {
      title = callback
        ? '画像の切り抜きができません'
        : '選択したファイルは使用できません';
      errorMessage = callback
        ? messageUtility.getMessage('E-000-201-04')
        : messageUtility.getMessage('E-000-201-03');
    }

    if (!isNullOrEmpty(errorMessage)) {
      state.workerImage.uploadStatus =
        FACE_PICTURE_UPLOAD_STATUS.uploadFailed.id;

      state.showImageSettingErrorDialog = true;
      state.informationModal.message = errorMessage;
      state.informationModal.title = title;
      state.informationModal.buttonText = messageUtility.getMessage(
        'I-000-017'
      );
      state.isLoading = false;
      callback && callback(true);
      this.setState(state);
      return;
    }

    await new Promise(() => {
      // base64バイナリを取得
      callback && callback(false);
      compressImage(
        imageBlob,
        result => {
          state.workerImage.imageUrl = URL.createObjectURL(result);
          state.workerImage.imageBinary = result;
          state.workerImage.imageName = fileName;
          state.workerImage.uploadStatus =
            FACE_PICTURE_UPLOAD_STATUS.uploadSuccess.id;
          state.isLoading = false;
          this.setState(state);
        },
        RAPIDA_FACE_IMAGE_RANGE_RESOLUTION.maxSize
      );
    });
  };

  /**
   * 顔画像登録フォーム
   * */
  updateFacePicture = () => {
    let state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }
    state.isLoading = true;
    this.setState(state, () => {
      let state = _.cloneDeep(this.state);
      const formData = WorkerImageService.createUpdateWorkerFacePicture(
        state.workerImage
      );
      WorkerImageApi.updateFacePicture(formData)
        .then(response => {
          if (response.result) {
            state.isLoading = false;
            state.dialogStatus = DIALOG_STATUS.updateSuccessDialogEnabled.id;
            state.informationModal.message = '顔写真の更新が完了しました。';
            state.informationModal.title = '顔写真更新完了';
            state.informationModal.buttonText = messageUtility.getMessage(
              'I-000-017'
            );
            state = this.clearDetailWorker(state);
            state = this.clearWorkerImage(state);
            state = this.clearListInfo(state);
            state.infiniteScrollLoadSearchForm = {
              ...state.infiniteScrollLoadSearchForm,
              ...state.searchForm,
            };
            this.setState(state, () => {
              this.loadWorkerSettingsList();
            });
          } else {
            state.isLoading = false;
            state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
            state.informationModal.message = extractErrorMessage(response);
            state.informationModal.title = messageUtility.getMessage(
              'E-000-005'
            );
            state.informationModal.buttonText = messageUtility.getMessage(
              'I-000-008'
            );
            this.setState(state);
          }
        })
        .catch(error => {
          alert(error);
          state.isLoading = false;
          this.setState(state);
        });
    });
  };

  reloadWorkerSettingsList = () => {
    const workersCount = this.state.workerList.length;
    const state = _.cloneDeep(this.state);
    this.setState(this.clearListInfo(state), () => {
      this.loadWorkerSettingsList({
        ...state.infiniteScrollLoadSearchForm,
        offset: 0,
        limit: workersCount,
      });
    });
  };

  searchClickHandle = () => {
    const state = _.cloneDeep(this.state);
    state.infiniteScrollLoadSearchForm = {
      ...state.infiniteScrollLoadSearchForm,
      ...state.searchForm,
    };
    state.canLoadMore = true;
    this.setState(this.clearListInfo(state), () => {
      this.loadWorkerSettingsList();
    });
  };

  /**
   * 作業員設定一覧を初期化する
   * @param state
   * @returns state
   */
  clearListInfo = state => {
    state.searchForm.total = 0;
    state.searchForm.offset = 0;
    state.searchForm.limit = null;
    state.workerList.length = 0;
    return state;
  };

  /**
   * 作業員設定一覧を取得する
   * */
  loadWorkerSettingsList = searchForm => {
    const state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }

    this.setState({ isLoading: true });
    WorkerSettingsApi.fetchWorkerSettingStatusList(
      state.fieldId,
      WorkerSettingsService.createSearchWorkerSettingList(
        searchForm || state.searchForm,
        BLACKLIST_SEARCH_KEYS[state.selectedTabId]
      )
    )
      .then(response => {
        const { result, data, message } = response;
        if (!result) {
          return alert(message);
        }
        state.searchForm.total = data.total;
        _.each(data.entities.worker_settings, item => {
          this.processImages(item);
          state.workerList.push(item);
        });
        if (!_.isEmpty(state.workerList)) {
          state.searchForm.offset = state.workerList.length;
          state.infiniteScrollLoadSearchForm.offset = state.workerList.length;
        }
      })
      .catch(error => {
        alert(error);
      })
      .finally(() => {
        const { workerList, searchForm } = state;
        state.isLoading = false;
        state.canLoadMore = _.size(workerList) < searchForm.total;
        this.setState(state);
      });
  };

  /**
   * ラピーダ連携（顔画像登録）を実行
   * */
  executeIntegration = () => {
    const state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);
    WorkerSettingsApi.registerFaceImages(state.fieldId)
      .then(response => {
        if (response.result) {
          state.dialogStatus = DIALOG_STATUS.registerStartDialogEnabled.id;
          state.informationModal.message = messageUtility.getMessage(
            'I-002-011-01'
          );
          state.informationModal.multilineText = true;
        } else {
          state.dialogStatus = DIALOG_STATUS.otherErrorDialogEnabled.id;
          state.informationModal.message = response.message;
        }

        state.informationModal.buttonText = messageUtility.getMessage(
          'I-000-017'
        );
      })
      .catch(error => {
        alert(error);
      })
      .finally(() => {
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * 作業員写真の処理
   * @param {*} worker 作業員情報
   */
  processImages = worker => {
    let allCcusSyncedStatuses = worker.worker_images.map(image => {
      const matching_status = _.find(WORKER_IMAGE_CCUS_SYNCED_STATUS, {
        id: image.ccus_synced_status,
      });
      let formatted = `${image.integration_service_name}：${matching_status.name}`;
      return {
        integration_service_name: image.integration_service_name,
        ccus_synced_status: image.ccus_synced_status,
        formatted,
      };
    });

    let allErrors = worker.worker_images.map(image => {
      if (image.has_error === false) {
        image.error_message = 'ー';
      }
      let formatted = `${image.integration_service_name}：${image.error_message}`;
      return {
        integration_service_name: image.integration_service_name,
        has_error: image.has_error,
        error_message: image.error_message,
        formatted,
      };
    });

    let ccusSyncedStatus =
      worker.worker_image_register_status === 1
        ? WORKER_IMAGE_CCUS_SYNCED_STATUS.notRegister.id
        : WORKER_IMAGE_CCUS_SYNCED_STATUS.excluded.id;
    if (allCcusSyncedStatuses.length > 0) {
      const allCcusSyncedStatusesSame =
        _.uniqBy(allCcusSyncedStatuses, item => item.ccus_synced_status)
          .length == 1;
      if (allCcusSyncedStatusesSame) {
        ccusSyncedStatus = allCcusSyncedStatuses[0].ccus_synced_status;
      } else {
        ccusSyncedStatus = WORKER_IMAGE_CCUS_SYNCED_STATUS.someRegister.id;
      }
    }
    if (isNullOrEmpty(worker.worker_image_exclusion_reason) === false) {
      ccusSyncedStatus = WORKER_IMAGE_CCUS_SYNCED_STATUS.excluded.id;
    }

    const hasError = allErrors.some(item => item.has_error);

    let errorMessage = 'ー';
    if (hasError) {
      const allErrorMessagesSame =
        _.uniqBy(allErrors, item => item.error_message).length == 1;
      if (allErrorMessagesSame) {
        errorMessage = allErrors[0].error_message;
      } else {
        const someWithoutError = allErrors.some(item => !item.has_error);
        if (someWithoutError) {
          errorMessage = ERROR_MESSAGE.someErrors;
        } else {
          errorMessage = ERROR_MESSAGE.allErrors;
        }
      }
    }

    worker.worker_image_info = {
      allCcusSyncedStatuses,
      allErrors,
      ccusSyncedStatus,
      hasError,
      errorMessage,
    };
  };

  toggleThumbnails = () => {
    const { isVisibleThumbnails } = this.state;
    if (!isVisibleThumbnails) {
      this.reloadWorkerSettingsList();
    }
    this.setState({ isVisibleThumbnails: !isVisibleThumbnails });
  };

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    let state = _.cloneDeep(this.state);

    state.fieldId = SessionStorageService.getFieldId();
    if (isNullOrEmpty(state.fieldId)) {
      state = this.showNotExistFieldIdDialog(state);
      this.setState(state);
      return;
    }

    // Objectの整形
    state.searchForm.workerSettingStatusList = _.values(WORKER_SETTING_STATUS);
    state.searchForm.workerSettingStatusList.length = 1;
    state.infiniteScrollLoadSearchForm.workerSettingStatusList = _.values(
      WORKER_SETTING_STATUS
    );
    state.infiniteScrollLoadSearchForm.workerSettingStatusList.length = 1;
    state.searchForm.workerImageRegisterStatusList = _.values(
      WORKER_IMAGE_REGISTER_STATUS
    );
    state.searchForm.workerImageCcusSyncedStatusList = _.values(
      _.filter(WORKER_IMAGE_CCUS_SYNCED_STATUS, 'canSearch')
    );
    state.searchForm.fieldTreeWorkerCcusSyncedStatusList = _.values(
      FIELD_TREE_WORKER_CCUS_SYNCED_STATUS
    );
    state.searchForm.fieldCcusEngineerIdStatus = _.values(
      CCUS_ENGINEER_ID_STATUS
    );
    state.searchForm.fieldConnectWorkHistoryStatus = _.values(
      CONNECT_WORK_HISTORY_STATUS
    );

    WorkerSettingsApi.fetchWorkerSettingStatusList(
      state.fieldId,
      WorkerSettingsService.createSearchWorkerSettingList(state.searchForm)
    )
      .then(response => {
        if (response.result) {
          state.searchForm.total = response.data.total;
          state.workerList = response.data.entities.worker_settings;
          state.workerList.forEach(worker => this.processImages(worker));
          if (state.workerList.length > 0) {
            state.searchForm.offset = state.workerList.length;
            state.infiniteScrollLoadSearchForm.offset = state.workerList.length;
          }
        }
      })
      .catch(error => {
        alert(error.data.message);
      })
      .finally(() => {
        FieldApi.loadField(state.fieldId)
          .then(response => {
            if (response.result) {
              state.showTab = !_.isEmpty(
                _.get(response, 'data.entities.field.ccus_site_id')
              );

              if (!isPrimaryCompanyRoleId(state.roleId)) {
                state.isLoading = false;
                this.setState(state);
                return;
              }
              Promise.all([
                FieldSettingsApi.fetchCheckInOutSettings(state.fieldId),
                FieldWorkerImageStatusesApi.registeredCount(state.fieldId),
              ])
                .then(responses => {
                  if (!responses[0].result) {
                    alert(extractErrorMessage(responses[0]));
                    return;
                  }
                  if (!responses[1].result) {
                    alert(extractErrorMessage(responses[1]));
                    return;
                  }
                  let data_0 = responses[0].data;
                  let data_1 = responses[1].data;
                  let integration_service_use_flg =
                    isNullOrEmpty(data_0.entities.check_in_out_setting) ==
                      false &&
                    Array.isArray(
                      data_0.entities.check_in_out_setting
                        .integration_service_ids
                    ) &&
                    data_0.entities.check_in_out_setting.integration_service_ids
                      .length > 0;
                  let registered_flg =
                    isNullOrEmpty(
                      data_1.entities.field_worker_image_statuses
                    ) == false &&
                    isNullOrEmpty(
                      data_1.entities.field_worker_image_statuses
                        .registered_count
                    ) == false &&
                    data_1.entities.field_worker_image_statuses
                      .registered_count > 0;
                  state.canUseFaceRegisterButton =
                    integration_service_use_flg || registered_flg;
                })
                .catch(error => {
                  alert(extractErrorMessage(error));
                })
                .finally(() => {
                  state.isLoading = false;
                  this.setState(state);
                });
            } else {
              state.isLoading = false;
              this.setState(state);
            }
          })
          .catch(error => {
            alert(error.data.message);
            state.isLoading = false;
            this.setState(state);
          });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showTab !== this.state.showTab) {
      EventMg.trigger(EventType.LAYOUT_UPDATE, {});
    }
    if (this.state.searchForm.clearFlag === true) {
      let stateVal = _.cloneDeep(this.state);
      stateVal.searchForm.clearFlag = false;
      this.setState(stateVal);
    }
  }

  /**
   * @description CSV出力準備
   */
  csvDownloadPreparation = () => {
    if (this.state.isLoading) {
      return;
    }

    const { searchForm, infiniteScrollLoadSearchForm, fieldId } = this.state;
    if (searchForm.total > data.CSV_EXPORT_LIMIT) {
      this.setState({ isCsvExportErrorDialog: true });
      return;
    }
    const params = WorkerSettingsService.createSearchWorkerSettingList(
      infiniteScrollLoadSearchForm,
      ['offset']
    );

    this.setState({ isLoading: true }, () => {
      WorkerSettingApi.fetchWorkerSettingListCSV(fieldId, params)
        .then(result => {
          if (result instanceof Blob) {
            WorkerSettingsService.downloadCsv(result, fieldId);
          } else {
            this.setState({ isCsvExportErrorDialog: true });
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    });
  };

  handleCloseCsvExportErrorDialog = () => {
    const state = _.cloneDeep(this.state);
    state.isCsvExportErrorDialog = false;
    this.setState(this.clearListInfo(state), () => {
      this.loadWorkerSettingsList({
        ...state.infiniteScrollLoadSearchForm,
        offset: 0,
      });
    });   
  };

  render() {
    return (
      <WorkerSettingsContext.Provider
        value={{
          state: this.state,
          changeTab: this.changeTab,
          searchFormHandle: this.searchFormHandle,
          searchFieldTreeId: this.searchFieldTreeId,
          searchCompanyId: this.searchCompanyId,
          searchConnectStatus: this.searchConnectStatus,
          inputWorkerName: this.inputWorkerName,
          checkSingleData: this.checkSingleData,
          clearSearchProperty: this.clearSearchProperty,
          closeDialog: this.closeDialog,
          infiniteScrollLoad: this.infiniteScrollLoad,
          changeSort: this.changeSort,
          showDetailDialog: this.showDetailDialog,
          showImageSettingDialog: this.showImageSettingDialog,
          closeImageSettingDialog: this.closeImageSettingDialog,
          closeImageSettingErrorDialog: this.closeImageSettingErrorDialog,
          executeIntegration: this.executeIntegration,
          deleteWorkerImage: this.deleteWorkerImage,
          fileUpload: this.fileUpload,
          updateFacePicture: this.updateFacePicture,
          toggleThumbnails: this.toggleThumbnails,
          searchClickHandle: this.searchClickHandle,
          csvDownloadPreparation: this.csvDownloadPreparation,
          handleCloseCsvExportErrorDialog: this.handleCloseCsvExportErrorDialog,
        }}
      >
        {this.props.children}
      </WorkerSettingsContext.Provider>
    );
  }
}

// 定数
const data = {
  CSV_EXPORT_LIMIT: 1000,
};


// WEBPACK FOOTER //
// ./src/services/workerSettings/WorkerSettingsStore.js